// extracted by mini-css-extract-plugin
export default {"Delete__Alert":"Delete_Delete__Alert__p4+xt","Delete__Actions":"Delete_Delete__Actions__fdx8O"};